import React, { Component } from 'react';
import { Card, Row, Col } from 'antd';
import { inject, observer } from 'mobx-react';

@inject('store')
@observer
export class InvoiceView extends Component {
    async componentDidMount() {
        await this.props.store.billingStore.getInvoice(this.props.match.params.id);
    }

    render() {
        console.log(this.props.store.billingStore.currentInvoice);
        const { currentInvoice } = this.props.store.billingStore;

        if (!currentInvoice) return null;

        return (
            <Card bordered={false} bodyStyle={{ background: '#fff', color: '#000' }}>
                <Row gutter={24}>
                    <Col span={12}>
                        <img src={'/logo.png'} height="40px" alt="Apex Trader Logo" />
                        <br />
                        www.apextrader.io
                    </Col>
                    <Col span={12}>
                        <h2>Invoice: </h2>
                        Date
                    </Col>
                </Row>

                <Row gutter={24} style={{ marginTop: 15 }}>
                    <Col span={12}>
                        <h2>Invoice To</h2>
                        {currentInvoice.name}
                        <br />
                    </Col>
                    <Col span={12}></Col>
                </Row>

                <table style={{ width: '100%' }}>
                    <thead>
                        <tr>
                            <th>Service Details</th>
                            <th>Price</th>
                        </tr>
                    </thead>
                    <tbody></tbody>
                </table>
            </Card>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/SubscriptionsView/InvoiceView.js